import React from 'react';
import { ModuleInterface } from '../types';
import { Select } from 'ui';

interface SelectFieldProps extends ModuleInterface {}

const SelectField: React.FC<SelectFieldProps> = ({ layout, ...field }) => {
    const commonProps = {
        url: field.endpoint,
        label: field.label,
        name: field.name,
        showSearch: true,
        allowClear: true,
        params: field.filters ?? {},
        labelInValue: true,
        customLayout: layout,
        method: field?.method ?? 'GET',
        searchKey: field?.searchKey ?? 'q',
        translation: field?.translation ?? '',
        validation: { required: field.required ?? false },
        localeTranslation: field.localeTranslation ?? false,
        cacheTime: field?.cacheTime ?? 0,
    };

    if (field.isEnum) {
        return <Select {...commonProps} />;
    }

    return (
        <Select
            {...commonProps}
            dataKey={field.dataKey ?? 'data'}
            valueKey={field.valueKey}
            labelKey={field.labelKey}
            isResponseArray={field.isResponseArray ?? true}
            integerKey={field.integerKey ?? false}
        />
    );
};

export default SelectField;
